/**
 * Points the product page's return line (sections/return-line.liquid) at the page the visitor
 * came from, when that was a collection or search results on this site, and goes back with
 * history.back() so the browser restores the grid where they left it. Anything else (a first
 * visit, another site, the homepage) keeps the server-rendered fallback collection.
 */
const link = document.querySelector('[data-return-line]');
const mapNode = document.querySelector('[data-return-line-map]');

function referrerUrl() {
  try {
    const url = new URL(document.referrer);
    return url.origin === window.location.origin && url.pathname !== window.location.pathname ? url : null;
  } catch {
    return null;
  }
}

function labelFor(url, titles) {
  const collection = url.pathname.match(/\/collections\/([^/]+)\/?$/);
  if (collection) {
    const handle = decodeURIComponent(collection[1]);
    if (titles[handle]) return titles[handle];
    if (handle === 'all') return link.dataset.shopLabel || null;
    return null;
  }
  if (/\/search\/?$/.test(url.pathname)) return link.dataset.searchLabel || null;
  return null;
}

if (link) {
  const from = referrerUrl();
  let titles = {};
  try {
    titles = JSON.parse(mapNode?.textContent || '{}');
  } catch {
    titles = {};
  }

  const label = from ? labelFor(from, titles) : null;
  const labelNode = link.querySelector('[data-return-line-label]');

  if (from && label && labelNode) {
    link.href = from.href;
    labelNode.textContent = label;

    link.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (window.history.length < 2) return;
      event.preventDefault();
      window.history.back();
    });
  }
}
